import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guarantees: [],
};

const bankingTypesSlice = createSlice({
  name: "bankingTypes",
  initialState,
  reducers: {
    populateBankingTypes(state, action) {
      return { ...state, bankingTypes: action.payload };
    },
  },
});

export const { populateBankingTypes } = bankingTypesSlice.actions;

export default bankingTypesSlice.reducer;
